import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 2H2v20l4-4h16V2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z"
}), 'RateReviewSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/RateReviewSharp.js
// module id = 5675
// module chunks = 2